import { sortOn } from 'src/helpers/utilities';
import { dateFormat } from 'src/helpers/date_helper';
import { deepCloneObj } from '..//chart_helper';
//Types
import type { ChartControlsDataInterface } from '../../ui/chart_control_helpers';
import type {
	GetStatsResponseData,
	GetStatsResponseHistoryData,
} from 'src/types/requests/charts/get_stats_period';

export const addLastHourConsumption = (
	resData: GetStatsResponseData,
	lastHourRes: GetStatsResponseData,
	chartControlsData: ChartControlsDataInterface,
	threeEM: boolean = false,
): GetStatsResponseData => {
	if (!lastHourRes?.history?.length) return resData;
	resData = deepCloneObj(resData);
	const lastHourResHistory: GetStatsResponseHistoryData[] = lastHourRes.history,
		firstItem = threeEM ? lastHourResHistory[0][0] : lastHourResHistory[0],
		date = new Date(firstItem.datetime);
	date.setMinutes(0);
	if (!/^(24_hours|day)$/.test(chartControlsData.rangeOption.period)) {
		date.setHours(0);
	}
	if (
		/^(6_months|12_months|year)$/.test(chartControlsData.rangeOption.period) ||
		(chartControlsData.rangeOption.period == 'custom' && resData?.interval == 'month')
	) {
		date.setDate(1);
	}
	const dateStr = dateFormat(date, chartControlsData.format);
	if (threeEM) {
		for (let i = 0; i < resData.history.length; i++) {
			//@ts-ignore
			resData.history[i] = addLastHourConsumptionByChannel(
				//@ts-ignore
				resData.history[i],
				lastHourResHistory[i],
				dateStr,
			);
		}
		resData.sum = addLastHourConsumptionByChannel(resData.sum, lastHourRes.sum, dateStr);
	} else {
		resData.history = addLastHourConsumptionByChannel(resData.history, lastHourResHistory, dateStr);
	}
	if (lastHourRes?.devices) {
		const items = lastHourRes.devices;
		for (const dev in items) {
			if (resData.devices[dev]) {
				resData.devices[dev].consumption += items[dev].consumption || 0;
				resData.devices[dev].reversed += items[dev].reversed || 0;
				resData.devices[dev].cost += items[dev].cost || 0;
			} else {
				resData.devices[dev] = items[dev];
			}
		}
	}
	return resData;
};

const addLastHourConsumptionByChannel = (
	resHistory: GetStatsResponseHistoryData[],
	lastHourResHistory: GetStatsResponseHistoryData[],
	date: string,
) => {
	const resHistoryCopy = resHistory.filter((i) => i.datetime != date);
	let items = addLastHourConsumptionDateset(lastHourResHistory, date);
	items = addLastHourConsumptionDateset(
		resHistory.filter((i) => i.datetime == date),
		date,
		items,
	);
	if (Object.keys(items).length > 0) {
		for (const i in items) {
			resHistoryCopy.push(items[i]);
		}
	}
	return sortOn(resHistoryCopy, 'datetime');
};

const addLastHourConsumptionDateset = (
	resHistory: GetStatsResponseHistoryData[],
	date: string,
	items = {},
) => {
	for (let i = 0; i < resHistory.length; i++) {
		const historyItem: GetStatsResponseHistoryData = resHistory[i];
		if (!historyItem?.missing) {
			const tariff_id = historyItem.tariff_id || '0';
			if (!items[tariff_id]) {
				items[tariff_id] = { ...historyItem, datetime: date };
			} else {
				items[tariff_id].consumption += historyItem.consumption;
				items[tariff_id].reversed += historyItem.reversed;
				items[tariff_id].cost += historyItem.cost;
				items[tariff_id].min_voltage =
					Math.min(items[tariff_id].min_voltage, historyItem.min_voltage) || 0;
				items[tariff_id].max_voltage = Math.max(
					items[tariff_id].max_voltage || 0,
					historyItem.max_voltage || 0,
				);
				items[tariff_id].voltage = Math.max(
					items[tariff_id].voltage || 0,
					historyItem.voltage || 0,
				);
			}
		}
	}
	return items;
};
